module.exports = __webpack_public_path__ + "img/copper-plate.8d01468c.png";